import React from 'react'

type Props = {
  locationLabel: string
  query?: string
  title: string
}

const Map = ({ locationLabel, query, title }: Props) => {
  const q = query || `${title}, ${locationLabel}`
  const googleMapsUrl = new URL('https://www.google.com/maps/embed/v1/place')
  googleMapsUrl.searchParams.append(
    'key',
    'AIzaSyBjUeLBA4LPKAlOKe0fxJdphWsqIzXYLoI'
  )
  googleMapsUrl.searchParams.append('q', q)

  return (
    <div className="-mx-4 md:mx-0 overflow-hidden">
      <iframe
        className="w-full min-w-[400px] h-80 md:h-96"
        src={googleMapsUrl.href}
      />
    </div>
  )
}

export default Map
